import { FC } from "react";
import { Box, Button, Toolbar, Typography, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

export interface ITimeSheetCategoryTrackingFieldsHeader{
    openNew: () => void;
    // selectedFieldPanelLabel: string;
}

export const TimeSheetCategoryTrackingFieldsHeader: FC<ITimeSheetCategoryTrackingFieldsHeader> = ({
    openNew,
    // selectedFieldPanelLabel,
}) => {
    const theme = useTheme();
    return (
        <Box>
            <Toolbar
                sx={{
                    // justifyContent: "end",
                    padding: "0!important",
                    "& .MuiButtonBase-root":{
                        marginBottom:"-13px"
                    }
                }}
            >
                <>
                    <Typography
                        sx={{
                            fontSize: "1.2rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        {/* {selectedFieldPanelLabel} */}
                    </Typography>
                    
                    <Button
                        size="medium"
                        startIcon={<AddIcon />}
                        variant="contained"
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.common.white,
                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                            },
                            textTransform: "none",
                            marginLeft: "auto",
                            "& .MuiSvgIcon-root":{
                                fontSize:"18px"
                            }
                        }}
                        onClick={openNew}
                    >
                        <Typography
                        sx={{
                            fontSize:".875rem"
                        }}
                        >Add</Typography>
                    </Button>
                </>
            </Toolbar>
        </Box>
    );
};
